module.exports = __webpack_public_path__ + "static/media/immeuble-fond-back.18f4cf0a.png";